import graphql__3ec886bf19d2bea3a390 from "./__generated__/ContributionsDatavizListItems_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useResponsiveFlag } from "../../../Utils/ResponsiveQueries";
import ContributionsDatavizListItemsTheme from "./ContributionsDatavizListItemsTheme";

const ContributionsDatavizListItems = props => {
  const participativeModule = useFragment(
    ContributionsDatavizListItems_participativeModule,
    props.participativeModule
  );
  const { themes } = participativeModule;

  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const className = classNames("listItems", {
    "margin-top-sm": isDesktop,
    "margin-top-md": isNonDesktop
  });

  return (
    <div className={className}>
      {themes.map(theme => (
        <div key={theme.id} className="contributions-dataviz-list-theme">
          {theme.children.length > 0 &&
            theme.children.map(subTheme => (
              <ContributionsDatavizListItemsTheme
                key={subTheme.id}
                theme={subTheme}
                participativeModule={participativeModule}
              />
            ))}

          {theme.children.length === 0 && (
            <ContributionsDatavizListItemsTheme
              key={theme.id}
              theme={theme}
              participativeModule={participativeModule}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ContributionsDatavizListItems;

const ContributionsDatavizListItems_participativeModule = graphql__3ec886bf19d2bea3a390;
